export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code: string,
    public readonly requestId?: string,
  ) {
    super(requestId ? `${message} (Reference: ${requestId})` : message);
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    credentials: "same-origin",
    headers: {
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
      ...init?.headers,
    },
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: { code?: string; message?: string } } | null;
    throw new ApiError(body?.error?.message ?? `Request failed with ${response.status}`, response.status, body?.error?.code ?? "request_failed", response.headers.get("x-request-id") ?? undefined);
  }
  return response.json<T>();
}

export async function downloadFile(path: string): Promise<{
  blob: Blob;
  filename: string;
}> {
  const response = await fetch(path, {
    credentials: "same-origin",
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: { code?: string; message?: string } } | null;
    throw new ApiError(
      body?.error?.message ?? `Request failed with ${response.status}`,
      response.status,
      body?.error?.code ?? "request_failed",
      response.headers.get("x-request-id") ?? undefined,
    );
  }
  const disposition = response.headers.get("content-disposition") ?? "";
  const filename = disposition.match(/filename="([^"]+)"/u)?.[1] ?? "crawler-run-summary.csv";
  return {
    blob: await response.blob(),
    filename,
  };
}
